const moneyFormat = window.theme.moneyFormat;

let universalTimeValue = Date.now();
var customization = true;
if($('.mrk-direct-bundle-add').length)
var customization = false;
$(document).ready(function() {
    $('.go-to-item').on('click', function() {
        var id = $(this).attr('id');
        $('.go-to-item').removeClass('bundle__build-item--active');
        $(this).addClass('bundle__build-item--active');
        $('.bundle_inside_wrap').removeClass('mx_active');
        $('.mrk-bundle-products-items').removeClass('mrk-bundle-active');
        $(`[mrk-bundle-products=${id}]`).addClass('mrk-bundle-active');
        $(`[mrk-bundle-products=${id}]`).closest('.bundle_inside_wrap').addClass('mx_active');
        updateNextPrevButton();
        $(`[mrk-bundle-products=${id}]`)[0].scrollIntoView({ behavior: "smooth", block: "center", inline: "nearest" });
        // $('html, body').animate({
        //     scrollTop: $(`[mrk-bundle-products=${id}]`).offset().top
        // }, 200); 
    });
    $('.mixmatch-open').on('click', function() {
        // Toggling the 'active' class on the clicked element
        $(this).toggleClass('active');

        // Toggling the 'bundle__details--open' class on its parent '.bundle__details'
        $(this).closest('.bundle__details').toggleClass('bundle__details--open');

        // Slide toggle on the nearest '.bundle__details-inner'
        $(this).parents('.bundle__details').find('.bundle__details-inner').slideToggle('fast');
    });
    function formatState (state) {
        if (!state.id) {
          return state.text;
        }
      
        var color = $(state.element).data('color');
        var $state = $(
          '<span class="detail__swatch">' +
            '<span class="detail__colour-swatch">' +
              '<span style="background: ' + color + ';"></span>' +
            '</span>' +
            '<span class="detail__text">' + state.text + '</span>' +
          '</span>'
        );
        
        return $state;
      };
      
    $('.mrk-color-picker').select2({
        templateResult: formatState,
        templateSelection: formatState,
        placeholder: "Select Colors"
    });
    $('.mrk-color-picker').on('select2:select select2:unselect', function(e) {
        var selectedOptions = $(this).val();
        if (selectedOptions.length > 0) {
            $(this).parents('.bundle__details-inner').find('.bundle__no-colours').addClass('hide-no-colours');
            $(this).parents('.bundle__details-inner').find('.mrk-selected-qty-text').show();

            let refEl = $(this)
            setTimeout(function(){
              updateBundleImage(refEl)
            }, 1000)
        } else {
            $(this).parents('.bundle__details-inner').find('.bundle__no-colours').removeClass('hide-no-colours');
            $(this).parents('.bundle__details-inner').find('.mrk-selected-qty-text').hide();

            let refEl = $(this)
            setTimeout(function(){
              updateBundleImage(refEl)
            }, 1000)
        }
      
        renderData($(this));
        updateSizeGuideTables2()
    });
});


function updateBundleImage(element) {
  var parentEl = element.parents('.bundle__details');
  var bundelItemImageEl = parentEl.find('img.bundle__item-featured-image');
  var bundelItemImageSrc = bundelItemImageEl.attr('data-native-img-url');
  var newColorImageSrc = parentEl.find('.bundle__colour-option').first().attr('data-featured-img-url');
  console.log("i am working...")
  console.log(bundelItemImageEl)
  console.log(newColorImageSrc)
  if (bundelItemImageEl && newColorImageSrc) {
    bundelItemImageEl.attr('src', newColorImageSrc);
  } else {
    bundelItemImageEl.attr('src', bundelItemImageSrc);
  }
}


function formatMoney(cents, format) {
  if (typeof cents === 'string') {
    cents = cents.replace('.', '');
  }
  let value = '';
  const placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
  const formatString = format || moneyFormat;

  function formatWithDelimiters(
    number,
    precision = 2,
    thousands = ',',
    decimal = '.'
  ) {
    if (isNaN(number) || number == null) {
      return 0;
    }

    number = (number / 100.0).toFixed(precision);

    const parts = number.split('.');
    const dollarsAmount = parts[0].replace(
      /(\d)(?=(\d\d\d)+(?!\d))/g,
      `$1${thousands}`
    );
    const centsAmount = parts[1] ? decimal + parts[1] : '';

    return dollarsAmount + centsAmount;
  }

  switch (formatString.match(placeholderRegex)[1]) {
    case 'amount':
      value = formatWithDelimiters(cents, 0);
      break;
    case 'amount_single':
      value = formatWithDelimiters(cents, 0);
      break;
    case 'amount_no_decimals':
      value = formatWithDelimiters(cents, 0);
      break;
    case 'amount_with_comma_separator':
      value = formatWithDelimiters(cents, 2, '.', ',');
      break;
    case 'amount_no_decimals_with_comma_separator':
      value = formatWithDelimiters(cents, 0, '.', ',');
      break;
  }

  return formatString.replace(placeholderRegex, value);
}

function preparePreview(file,container) {
  // Reset potential changes from previous uploads
  $(container).find('.mrk-progress').show();
  $(container).find('.mrk-upload').css('width', '0%');
  $(container).find('.mrk-error-message span').text('');

  // Display the file name and show the preview
  $(container).find('.mrk-filename span[data-mrk-name]').text(file.name);
  $(container).find('.preview-template').show();
}

function uploadFile(file,container) {
  var formData = new FormData();
  formData.append('file', file);

  $.ajax({
      url: 'https://jrsindustrial-files.com',
      type: 'POST',
      data: formData,
      cache: false,
      contentType: false,
      processData: false,
      beforeSend: function(){
        $('.mrk-steps-footer').addClass('loading');
      },
      xhr: function() {
          var xhr = new XMLHttpRequest();
          xhr.upload.addEventListener("progress", function(e) {
              if (e.lengthComputable) {
                  var percentComplete = (e.loaded / e.total) * 100;
                  $(container).find('.mrk-upload').css('width', percentComplete + '%');
              }
          });
          return xhr;
      },
      success: function(response) {
          // console.log(response);
          // response = JSON.parse(response);
          var url = 'https://jrsindustrial-files.com/' + response.filePath;
          $(container).find('.mrk-image img').attr('src', url);  // Set the image source
          $(container).find('.input-file-logo').val(url);
          $(container).find('.mrk-progress').hide(); // Hide the progress bar on success
          $('.mrk-steps-footer').removeClass('loading');
          $('.mrk-steps-footer').removeClass('mrk-disable-btn');
      },
      error: function(jqXHR, textStatus, errorThrown) {
        $(container).find('.mrk-error-message span').text('Upload error: ' + textStatus);
        $(container).find('.mrk-progress').hide(); // Hide the progress bar on error
      }
  });
}
// customizer steps
function calculatePrice(){
  var sizes = $('.mrk-qty-item'),totalPrice = 0;
  const positions = $('.mrk-logo-inputs:checked');
  const isEmbroidery = $('[name="application-type"]:checked').val() == 'Embroidery' ? true:false;
  const positionsPrice = getAllPositionsPrice(isEmbroidery,positions);
  const logoTypePrice = Number($('[name="logo-type"]:checked').attr('price')) || 0;
    var qty = 1;
    var price = 0;
    if(qty>0){
    var variantPrice = window.bundlePrice;
    var price = positionsPrice;
    var finalPrice = (price*qty) + (variantPrice * qty) + logoTypePrice;
    totalPrice = totalPrice + finalPrice;
    }
  $('.mrk-final-price').html(formatMoney(totalPrice));
}
function getAllPositionsPrice(isEmbroidery,positions){
  var priceTotal = 0,price;
  positions.each(function(){
    if(isEmbroidery){
      price = Number($(this).data('embroideryprice'));
    }else{
      price = Number($(this).data('printprice'));
    }
    priceTotal = priceTotal + price;
  })
  return priceTotal;
}
function positionsData(){
  positionData = [];
  $('.mrk-hidden-field-item').map(function() {
    positionData.push(JSON.parse($(this).html()));
  })
  return positionData;
}
function getAllPositionsVariants(){
  var allPositionsItem = [], positionsDataArray = positionsData();
  positionsDataArray.forEach(function(positionData, index){
      var bundleItemPositions = positionData[`Positions ${index + 1}`];
      bundleItemPositions.forEach(function(bundleProperty, index){
        var id = bundleProperty.variantID, ParentVariantId = bundleProperty.ParentVariantId,property = bundleProperty.property,qty=bundleProperty.qty;
        allPositionsItem.push(buildItem(id,qty,ParentVariantId,property));
      })
  });
  console.log(allPositionsItem, 'mrk-allPositionsItem');
  return allPositionsItem;
}
function getAllPositionsProperties(isEmbroidery,positions,qty,ParentVariantId,property){
  var allPositionsItem = [],id;
  positions.each(function(){
    // if(Number($(this).data('printprice')) == 0 && Number($(this).data('embroideryprice')) == 0){
    //   return
    // }
    if(isEmbroidery){
      id = Number($(this).data('embroideryvariant'));
    }else{
      id = Number($(this).data('printvariant'));
    }
    var name = $(this).val();
    allPositionsItem.push({variantID:id,name:name,qty:qty,ParentVariantId:ParentVariantId,property:property});
  })
  return allPositionsItem;
}
function updateContentInfo(image, color){
  $('.mrk-popup-product-image').attr('src', image);
  $('.selected-color').text(color);
}
function UpdatePositionPrices(){
  const isEmbroidery = $('[name="application-type"]:checked').val() == 'Embroidery' ? true:false;
  var price;
  const positions = $('.mrk-logo-inputs');
  positions.each(function(){
    if(isEmbroidery){
      price = Number($(this).data('embroideryprice'));
    }else{
      price = Number($(this).data('printprice'));
    }
    var formatted_price = formatMoney(price);
    $(this).next('.mrk-abs-price-position').html(`+${formatted_price}`)
  })
}
async function addBulkItems(){
  var bundleItems = $('.mrk-bundle-products-items');
  var ids = [];
  var qty = 1;
  var ParentVariantId = window.bundleId;
  const mainVariant = buildMainVariant(ParentVariantId,qty,bundleItems);
  if(customization){
    var currentIds = [];
    const positionsVariants = getAllPositionsVariants();
    currentIds = currentIds.concat(positionsVariants);
    ids = ids.concat(currentIds)
  }
  ids.push(mainVariant);
  var data = {
    items: ids
  }
  if(window.updates != undefined){
    $('.mrk-loader-main').css('display', 'flex');
    jQuery.post(window.Shopify.routes.root + 'cart/update.js', {
        updates: updates
    }, function (response) {
      var refreshCart = true;
      addItemToCart(data,refreshCart);
    }).fail(function () {
        // Handle error
        console.log('Error updating cart.');
    });
  }else{
    var refreshCart = false;
    addItemToCart(data,refreshCart);
  }
}
function addItemToCart(data,refreshCart){
  jQuery.ajax({
    type: 'POST',
    url: '/cart/add.js',
    data,
    dataType: 'json',
    beforeSend :function(){
      $('.mrk-loader-main').css('display', 'flex');
    },
    success: function(resp) {
      if(refreshCart == 'notification'){
        initNotification(resp);
      }
      else if(refreshCart){
        $('.mrk-customizer-cart').hide()
        updateCart();
      }else{
      location.pathname = '/cart'
      // console.log(resp)
      }
    }
  });
}
function buildMainVariant(ParentVariantId,qty,bundleItems){
  var bundle = []; 
  var properties = {};
  var index_ = 1;
  bundleItems.each(function() {
    var bundleItemName = $(this).attr('bundleitemName');
    var bundleIndex = $(this).attr('bundleitem'),allPositionsItem=[];
    var bundleProperties = positionsData();
    // Find or create the bundle object
    var bundleObject = bundle.find(b => b.name === bundleItemName);
    if (!bundleObject) {
        bundleObject = { name: bundleItemName, products: {} };
        bundle.push(bundleObject);
    }
    bundleProperties.forEach(function(positionData, index){
        var bundleItemPositions = positionData[`Positions ${index+1}`];
        bundleItemPositions.forEach(function(bundleProperty, index){
          var name = bundleProperty.name ,qty=bundleProperty.qty;
          $(`[bundleitem="${bundleIndex}"] .mrk-qty-item`).each(function(){
            if(Number($(this).val()) > 0){
              if($(this).attr('productname') == bundleProperty.property){
                allPositionsItem.push({name: name, qty: qty, bundleName: bundleItemName });
              }
            }
          });
        })
    });
    allPositionsItem = allPositionsItem.filter((position, index, self) =>
      index === self.findIndex((p) => (
          p.name === position.name && p.qty === position.qty && p.bundleName === position.bundleName
      ))
    );
    var sizes = $(this).find('.mrk-qty-item');
      var _index = 1;
    $(sizes).each(function() {
        if (Number($(this).val()) > 0) {
            var size = $(this).attr('size'),
            color = $(this).attr('color'),
            sku = $(this).attr('sku'),
            name = $(this).attr('productName'),
            qty = Number($(this).val()),
            productName = `Product_${_index}`;
            if(customization){
            bundleObject.positions = allPositionsItem;
            }
            bundleObject.products[productName] = { name: name, color: color, size: size,quantity: qty, sku:sku };
            _index = _index + 1;
        }
    });
  });
  var bundleProperties = positionsData();
  bundleProperties.forEach(bundle => {
      for (let key in bundle) {
          if (!key.includes("Positions")) {
              properties[key] = bundle[key];
          }
      }
  });
  // Stringify and log the bundle array
  var jsonString = JSON.stringify(bundle);
  var mrkPage_url = 'https://jrsindustrial.co.uk/pages/bundle?bundle=' + jsonString;
  var genricProperties = {
    '_bundle': mrkPage_url,
    '_bundle_raw': bundle
  };
  const newProperties = Object.assign({}, genricProperties, properties);
  return({
    quantity: qty,
    id:ParentVariantId,
    properties: newProperties
  })
}
function buildItem(id,qty,ParentVariantId,property){
  if(ParentVariantId == ''){
    return ({
      quantity: qty,
      id
    })
  }else{
    return ({
      quantity: qty,
      id,
      properties: {
        '_ParentVariant': ParentVariantId,
        '_qty': qty,
        '_time': universalTimeValue
      }
    })
  }
  
}

function updateSizeGuideTables2() {
  var tableHtml = '';
  if (window.template.template.includes("bundle")) {
    let kiwiSizingModal = document.querySelector('.kiwi-sizing-modal')
    if (kiwiSizingModal) {
      $('.bundle__colour-header .customSizeGuideButton').css('display', 'flex');
      $('.custom-size-guide-text').css('display', 'block');
    } else {
      $('.bundle__colour-header .customSizeGuideButton').css('display', 'none');
      $('.custom-size-guide-text').css('display', 'none');
    }
  }
  else {
    $('.mrk-size-guide-table').each(function () {
        if ($(this).html() !== '') {
            tableHtml = $(this).html();
            $('.bundle__colour-header .customSizeGuideButton').css('display', 'flex');
            $('.custom-size-guide-text').css('display', 'block');
        }
    });
    $('.mrk-size-guide-table').each(function () {
        if ($(this).html() === '') {
            $(this).html(tableHtml);
            $('.bundle__colour-header .customSizeGuideButton').css('display', 'none');
            $('.custom-size-guide-text').css('display', 'none');
        }
    });
  }
}

function renderData(select){
    $('.mrk-bundle-loader-main').css('display', 'flex');
    var selectedOptions = $(select).find('option:selected');
    var ajaxCalls = [];
    var urls = new Set(); // To keep track of already processed URLs

    selectedOptions.each(function() {
        var variantUrl = $(this).attr('varianturl') + '&view=bundleSizes';
      console.log('variantUrl',variantUrl);
        if (variantUrl) {
            ajaxCalls.push($.ajax({
                url: variantUrl,
                method: 'GET',
                cache: true
            }));
        }
    });

    if (ajaxCalls.length === 0) {
        // No options selected, clear the HTML
        $(select).parents('.bundle__details').find('.bundle__details-inner .bundle__colour-options').html('');
        $('.mrk-bundle-loader-main').hide();
        return;
    }

    $.when.apply($, ajaxCalls).then(function() {
        var combinedHtml = '';
        if (ajaxCalls.length > 1) {
            // Multiple calls, arguments is an array of responses
            $.each(arguments, function(index, responseData) {
              
                combinedHtml += responseData[0];
            });
        } else {
            // Single call, arguments is the response data directly
          // console.log('responseData',arguments[0])
            combinedHtml = arguments[0];
        }

        $(select).parents('.bundle__details').find('.bundle__details-inner .bundle__colour-options').html(combinedHtml);
        $('.mrk-bundle-loader-main').hide();
        bindEvents()
    });
}

function bindEvents(){
    $('.bundle__details-inner .mrk-qty-item').off('change');
    $('.bundle__details-inner [data-action="decrement"]').off('click');
    $('.bundle__details-inner [data-action="increment"]').off('click');
    $('.bundle__details-inner [data-action="decrement"]').click(function() {
        // Find the nearest input of type number and decrement its value
        var $input = $(this).parents('.stock').find('.mrk-qty-item');
        var currentValue = parseInt($input.val(), 10);
        var minValue = $input.attr('min') ? parseInt($input.attr('min'), 10) : 0;
        
        if (currentValue > minValue) {
            $input.val(currentValue - 1).change();
        }
        upDateTotals();
    });

    // Handle increment action
    $('.bundle__details-inner [data-action="increment"]').click(function() {
        // Find the nearest input of type number and increment its value
        var $input = $(this).parents('.stock').find('.mrk-qty-item');
        var currentValue = parseInt($input.val(), 10);
        var maxValue = $input.attr('max') ? parseInt($input.attr('max'), 10) : 100; // Default max value is set to 100
        var total = 0;
        var limit = Number($('.bundle__build-item--active').attr('limit'));
        $(this).parents('.bundle__colour-options').find('.mrk-qty-item').each(function(){
            total = total + Number($(this).val())
        })
        if(total > limit){
            $($input).val(0);
            alert(`You can maximum add ${limit}.`)
            return;
        }
        if(total == limit){
            upDateTotals();
            return;
        }
        
        if (currentValue < maxValue) {
            $input.val(currentValue + 1).change();
        }
        upDateTotals();
    });
    $('.bundle__details-inner .mrk-qty-item').on('change',function(){
      var total = 0;
      var limit = Number($('.bundle__build-item--active').attr('limit'));
      $(this).parents('.bundle__colour-options').find('.mrk-qty-item').each(function(){
          total = total + Number($(this).val())
      })
      if(total > limit){
          $(this).val(0);
          alert(`You can maximum add ${limit}.`)
          return;
      }else{
        upDateTotals();
      }
    });
}
function UpdateBundle(){
    var bundleItems = {};

    $('.mrk-bundle-products-items .mrk-qty-item').each(function() {
        var indexArray = Number($(this).parents('.mrk-bundle-products-items').attr('bundleItem'));

        if (!bundleItems['bundleItem_' + indexArray]) {
            bundleItems['bundleItem_' + indexArray] = [];
        }

        var itemObject = {
            quantity: $(this).val(),
            variantId: $(this).attr('data-variant-id')
        };
        if($(this).val()>0)
        bundleItems['bundleItem_' + indexArray].push(itemObject);
    });

    // console.log(bundleItems);
}
function calculateTotal(){
    var total = 0;
    $('.bundle__options-contain').find('.mrk-qty-item').each(function(){
        total = total + Number($(this).val())
    });
    $('.bundle__build .selected_products').text(total);
}
function upDateTotals(){
    var limit = Number($('.bundle__build-item--active').attr('limit'));
    var BundleItemTotal = 0,bundleTotal=0;
    $('.mrk-bundle-active .mrk-qty-item').each(function(){
        var value = Number($(this).val());
        if(value>0){
            BundleItemTotal = BundleItemTotal + value;
        }
    });
    $('.mrk-bundle-active .mrk-selected-qty').text(limit - BundleItemTotal);
    $('.bundle__build-item--active .current_quantity_130').text(BundleItemTotal);
    if(BundleItemTotal == limit){
        $('.mrk-bundle-active .mrk-selected-qty-text').hide();
        $('.mrk-bundle-active .bundle__colour-options').addClass('mrk-options-disabled');
        $('.bundle__build-item--active').addClass('bundle__build-item--completed');

        $('.mixmatch-open.active').each(function(){
          $(this).click()
        });
      
        // closing the '.bundle_inside_wrap' after selection
        setTimeout(function(){
          $('.bundle__build-item--active.bundle__build-item--completed').closest('.bundle_inside_wrap').find('.mrk-bundle-products-items').removeClass('mrk-bundle-active')
          $('.bundle__build-item--active.bundle__build-item--completed').closest('.bundle_inside_wrap').removeClass('mx_active')
          $('.bundle__build-item--active.bundle__build-item--completed').removeClass('bundle__build-item--active')
        }, 0)
        // -----
      
        setTimeout(function(){
          $('.bundle__build')[0].scrollIntoView({ behavior: "smooth", block: "center", inline: "nearest" });
        },400)
    }else if(BundleItemTotal < limit){
        $('.mrk-bundle-active .mrk-selected-qty-text').show();
        $('.mrk-bundle-active .bundle__colour-options').removeClass('mrk-options-disabled');
        $('.bundle__build-item--active').removeClass('bundle__build-item--completed');
    }
    $('.mrk-bundle-active .bundle__details--mix-and-match').each(function(){
        var productTotal = 0
        $(this).find('.mrk-qty-item').each(function(){
            var value = Number($(this).val());
            if(value>0){
                productTotal = productTotal + value;
            }
        });
        $(this).find('.amount-selected').text(productTotal)
    });
    $('.bundle__details--mix-and-match .mrk-qty-item').each(function(){
        var value = Number($(this).val());
        if(value>0){
            bundleTotal = bundleTotal + value;
        }
    });
    $('.bundle__build .selected_products').text(bundleTotal)
    window.bundleTotal = bundleTotal;
    updateNextPrevButton();
}
function updateNextPrevButton(){
    var $current = $('.bundle__build-item.bundle__build-item--active');
    var $prev = $current.prev('.bundle__build-item');
    var $next = $current.next('.bundle__build-item');
    if ($prev.length) {
        $('.previous-bundle-product').show()
    }else{
        $('.previous-bundle-product').hide()
    }
    if ($next.length) {
        $('.next-bundle-product').show()
    }else{
        $('.next-bundle-product').hide()
    }
    if(window.bundleTotal == window.totalLimit){
        $('.next-bundle-product').hide();
        $('.mrkfinal-add-logo,.mrk-direct-bundle-add').show();
    }else if ($next.length) {
        $('.next-bundle-product').show();
        $('.mrkfinal-add-logo,.mrk-direct-bundle-add').hide();
    }else{
        $('.mrkfinal-add-logo,.mrk-direct-bundle-add').hide();
    }
}
// new js code  
function getLogoDetails(index) {
  var logoType = $('[name="logo-type"]:checked').val();
  var logo = {};

  if (logoType == 'Upload Your Logo') {
      logo = {
          [`Logo ${index}`]: $('[name="properties[Uploaded Logo]"]').val(),
          [`Note ${index}`]: $('#customerNotesFilesUploadedLogo').val()
      };
  } else if (logoType == 'Existing Logo') {
      logo = {
          [`Logo ${index}`]: $('[name="properties[Existing Logo]"]').val(),
          [`Note ${index}`]: $('#customerNotesFilesExisting').val()
      };
  } else if (logoType == 'Text Logo') {
      logo = {
          [`Logo Text ${index}`]: $('[name="properties[Text Line]"]').val(),
          [`Logo Text 2 ${index}`]: $('[name="properties[Text Line 2]"]').val(),
          [`Logo Text 3 ${index}`]: $('[name="properties[Text Line 3]"]').val(),
          [`Logo Text 4 ${index}`]: $('[name="properties[Text Line 4]"]').val(),
          [`Logo Color ${index}`]: $('#logoColor').val(),
          [`Logo Font ${index}`]: $('#font-family').val(),
          [`Note ${index}`]: $('#notesLogoText').val()
      };
  }
  // console.log(logoType, logo);
  return logo;
}

function addHiddenField(index, properties) {
  var hiddenField = $('<div class="mrk-hidden-field-item"></div>').attr('data-index', index);
  $(hiddenField).html(JSON.stringify(properties));
  // console.log(JSON.stringify(properties),properties);
  $('.mrk-hidden-fields').append(hiddenField);
}
function updateMeta() {
  var bundleItems = $('.mrk-bundle-products-items');
  const isEmbroidery = $('[name="application-type"]:checked').val() == 'Embroidery' ? true:false;
  var ParentVariantId = window.bundleId, positionsData = [];
  bundleItems.each(function(){
    var bundleIndex = $(this).attr('bundleitem');
    const positions = $(`.mrk-position-item .mrk-logo-inputs[forbundle="bundleItem-${bundleIndex}"]:checked`);
    var sizes = $(this).find('.mrk-qty-item');
    $(sizes).each(function(){
        if(Number($(this).val())>0){
            var property = $(this).attr('productname');
            var qty = Number($(this).val());
            if(qty>0){
            const positionData = getAllPositionsProperties(isEmbroidery,positions,qty,ParentVariantId,property);
            positionsData = positionsData.concat(positionData)
            }
        }
    })
  });
  var index = $('.mrk-hidden-fields .mrk-hidden-field-item').length + 1;
  var logoDetails = getLogoDetails(index),
      applicationMethod = $('[name="application-type"]:checked').val(),
      logoVariant = $('[name="logo-type"]:checked').attr('variant'),
      position = $('.mrk-position-item input:checked').val(),
      logoType = $('[name="logo-type"]:checked').val();
  var genericProperties = {
      [`Application Method ${index}`]: applicationMethod,
      [`Positions ${index}`]:positionsData,
      [`Logo Type ${index}`]: logoType,
      [`_logoVariant${index}`]: logoVariant,
      [`_time`]: universalTimeValue
  };
  var properties = Object.assign({}, genericProperties, logoDetails);
  addHiddenField(index, properties);
  // Disable current checked positions
  $('.mrk-position-item input:checked').each(function() {
    $(this).prop('disabled', true).parents('.mrk-position-item').addClass('mrk-checked-position');
  });
}
function handleLogo(){
  $('.mrk-add-another-logo').on('click', function() {
    updateMeta();
    initExistingLogos();
    $('.mrk-close-btn').click();
    // Reset position selections
    $('.mrk-position-item input').prop('checked', false);

    // Reset logo type and details
    $('[name="logo-type"]').prop('checked', false);
    $('[name="properties[Uploaded Logo]"]').val('');
    $('#customerNotesFilesUploadedLogo').val('');
    $('[name="properties[Existing Logo]"]').val('');
    $('#customerNotesFilesExisting').val('');
    $('[name="properties[Text Line]"]').val('');
    $('#logoColor').val('');
    $('#font-family').val('');
    $('#notesLogoText').val('');

    // $('#previewDiv').text('JRS');
    $('#logoText').val('JRS');
    $('#previewDivLine1').html('JRS');
    $('#previewDivLine2').html('');
    $('#previewDivLine3').html('');
    $('#previewDivLine4').html('');
    window.mrknavigateTo(0);
  });
}
function initPopup(){
    $('.mrk-product-csutomizer input').change(function (e) { 
      e.preventDefault();
      calculatePrice()
    });
    $('[name="application-type"]').change(function (e) { 
      e.preventDefault();
      UpdatePositionPrices();
    });
    $('.mrk-final-add-to-cart').click(function (e) { 
      e.preventDefault();
      updateMeta();
      const positionsCount = $('.mrk-checked-position').length + $('.mrk-position-item input:checked').length;
      if(positionsCount == 0){
        alert('Select Positions!');
        window.mrknavigateTo(1);
        return;
      }
      const logoType = $('[name="logo-type"]:checked');
      if(logoType.length == 0){
        alert('Select Logo Type!');
        window.mrknavigateTo(2);
        return;
      }
      addBulkItems()
    });
    $('.popup__close.customizer-popup').click(function (e) { 
        e.preventDefault();
        $('.mrk-customizer-popup-form .popup-overlay').removeClass('show')
    });
    multiStepForm($(".mrk-multistep"),{defaultStep: 0});
    $('.mrkfinal-add-logo').click(function (e) { 
        e.preventDefault();
        $('.mrk-customizer-popup-form .popup-overlay').addClass('show');
    });
    $('.mrk-direct-bundle-add').click(function (e) { 
        e.preventDefault();
      addBulkItems()
    });
  
    // On change of text input
    $('#logoText').on('input', function() {
      // $('#previewDiv').html($(this).val());
      $('#previewDivLine1').html($(this).val());
      if($(this).val() != ''){
        $('.mrk-steps-footer').removeClass('mrk-disable-btn');
      }else{
        $('.mrk-steps-footer').addClass('mrk-disable-btn');
      }
      
    });
    $('#logoText2').on('input', function() {
       $('#previewDivLine2').html($(this).val());
    });
    $('#logoText3').on('input', function() {
      $('#previewDivLine3').html($(this).val());
    });
    $('#logoText4').on('input', function() {
      $('#previewDivLine4').html($(this).val());
    });
    
    // On change of font dropdown
    $('#font-family').change(function() {
      const fontFamily = $(this).val();
      $('#previewDiv').css('font-style', fontFamily);
    });
    
    // On change of color dropdown
    $('#logoColor').change(function() {
      const color = $(this).val();
      const bg = $('#logoColor option:selected').attr('bg') || 'black';
      $('#previewDiv').css('color', color).css('background', bg);
    });
    $('.mrk-close-btn').click(function() {
      $('.input-file-logo').val('');
      $('[data-mrk-thumbnail]').attr('src','');
      $('.preview-template').hide();
      $('.hiddenFileInput').val('').change();
    });
    // uploader
    // When a file is chosen using the file input, upload it
    $('.hiddenFileInput').change(function() {
      var container = $(this).parents('.tab');
      var file = this.files[0];
      if (file) {
          preparePreview(file,container);
          uploadFile(file,container);
      }
    });
    UpdatePositionPrices();
    
  
      // Handle input change 
    function handleInputChange(input) {
        const container = $(input).parents('.mrk-step-existing-logo'); // Find the parent tab container
        const file = $(input).val(); // Get the value (URL)

        // Display the file name and show the preview
        $(container).find('.input-file-logo').val(file);
        console.log($(container).find('.input-file-logo'), file, $(container));
        $(container).find('.mrk-filename span[data-mrk-name]').text(file.replace('https://jrsindustrial-files.com/uploads/', ''));
        $(container).find('.preview-template').show();
        $(container).find('.mrk-image img').attr('src', file);
        $(container).find('.mrk-progress').hide(); // Hide the progress bar on success
        $('.mrk-steps-footer').removeClass('loading');
        $('.mrk-steps-footer').removeClass('mrk-disable-btn');
    }
  // Attach change event listener to dynamically created inputs
  $(document).on('change', '.mrk-existing-logo-item', function () {
    handleInputChange($('.mrk-existing-logo-item:checked'));
  });
  initExistingLogos();
  handleLogo()
}
function initExistingLogos(){
  // Parse the stored logos from localStorage
  const logos = JSON.parse(localStorage.getItem('logos')) || [];
  
  // Generate the HTML and append it to a container
  const $container = $('.mrkexisting-logo-select'); // Replace with your actual container selector
  if(logos.length){
    $('.mrk-existing-logo-wrapper').show();
    $($container).html('');
    $('.mrk-existing-logo-selector').show()
  }
  logos.forEach((logo, index) => {
    const logoItem = `
      <div class="logo-item">
        <input type="radio" name="mrk-existing-logo" value="${logo}" class="mrk-existing-logo-item" id="mrk-existing-logo-${index}" />
        <label for="mrk-existing-logo-${index}">
          <img src="${logo}" class="mrk-exiting-logo-image" />
        </label>
      </div>
    `;
    $container.append(logoItem);
  });
}
$('.next-bundle-product').click(function() {
    var $current = $('.bundle__build-item.bundle__build-item--active');
    var $next = $current.next('.bundle__build-item');

    if ($next.length) {
        $next.click();
    }
});

$('.previous-bundle-product').click(function() {
    var $current = $('.bundle__build-item.bundle__build-item--active');
    var $prev = $current.prev('.bundle__build-item');

    if ($prev.length) {
        $prev.click();
    }
});
initPopup()